/* globals zoomSdk */
import { ReactElement, useState } from 'react'
import { Dialog } from '@zoom/react-ui'
import FormDropdown from './FormDropdown'
import { App } from '../../app/root'
import FileNameTitle from './FileNameTitle'

export type Option = {
  label: 'Editor' | 'Viewer' | 'Commenter' // This goes in the dropdown for user to select
  verb: 'edit' | 'view' | 'comment' // In the text below
  value: 'editor' | 'viewer' | 'commenter' // The actual role. Only needed for the API endpoints
}

export type OptionEvent = {
  target: { value: Option }
}

type FilePermissionsProps = {
  options: Option[]
  onChange: (value: Option['value']) => void
  handleGrant: () => void
  onClose: () => void
  fileName: string
  fileUrl?: string
  icon: ReactElement
  app: App
}

const FilePermissions: React.FC<FilePermissionsProps> = ({
  options,
  onChange,
  handleGrant,
  onClose,
  fileName,
  fileUrl,
  icon,
  app,
}) => {
  const defaultOptionIndex = app === 'Google' ? 2 : 1
  const [selectedOption, setSelectedOption] = useState<Option>(
    options[defaultOptionIndex]
  )

  const handleDropdownChange = (e: OptionEvent) => {
    setSelectedOption(e?.target?.value)
    onChange(e?.target?.value?.value)
  }

  const handlePreview = async (url: string) => {
    zoomSdk.openUrl({ url })
  }

  return (
    <Dialog
      onOk={handleGrant}
      onCancel={onClose}
      onEscapeKeyDown={onClose}
      onBackdropClick={onClose}
      okText='Grant access'
      sx={{
        '.ui-Dialog-paper-root': {
          minWidth: '320px',
          minHeight: '208px', // force full size of dialog when at smaller screen heights
        },
      }}
      title={
        fileUrl ? (
          <FileNameTitle
            fileName={fileName}
            icon={icon}
            onLinkClick={() => handlePreview(fileUrl)}
          />
        ) : (
          <div className='flex max-w-[280px] gap-2 truncate !text-customGray'>
            {icon} Share a new document
          </div>
        )
      }
    >
      <div className='w-full'>
        <div className='mb-1 flex flex-row items-center justify-between'>
          <div className='text-custom-14px'>Meeting Invitees</div>
          <FormDropdown
            options={options}
            onChange={handleDropdownChange}
            defaultOptionIndex={defaultOptionIndex}
          />
        </div>
        <div className='mb-1'>
          <div className='text-xs font-light'>
            {`Everyone invited to the meeting can ${selectedOption?.verb || 'edit'}`}
          </div>
        </div>
      </div>
    </Dialog>
  )
}

export default FilePermissions

/*
Share
border-top-width: 0px;
box-sizing: border-box;
color: rgb(50, 53, 57);
display: block;
font-family: Roboto, Helvetica, Arial, sans-serif;
font-feature-settings: normal;
font-size: 20px;
font-style: normal;
font-variation-settings: normal;
font-weight: 600;
height: 24px;
letter-spacing: 0.15px;
line-height: 24px;
margin-left: 7px;
tab-size: 4;
width: 56.34375px;

file
border-top-width: 0px;
box-sizing: border-box;
color: rgb(50, 53, 57);
cursor: pointer;
display: block;
font-family: system-ui, "Segoe UI Emoji", "Segoe UI Symbol", "Segoe UI", "Apple Color Emoji", "Twemoji Mozilla", "Noto Color Emoji", "Android Emoji", "SF Pro", "Almaden Sans", Roboto, Ubuntu, Helvetica, Arial;
font-feature-settings: normal;
font-kerning: auto;
font-optical-sizing: auto;
font-size: 20px;
font-size-adjust: none;
font-stretch: 100%;
font-style: normal;
font-variant-alternates: normal;
font-variant-caps: normal;
font-variant-east-asian: normal;
font-variant-ligatures: normal;
font-variant-numeric: normal;
font-variant-position: normal;
font-variation-settings: normal;
font-weight: 600;
height: 24px;

*/
